<script lang="ts">
  import { Icon } from '@shared/ui/icon';

  import type { CuratorType } from '@entities/curator';

  type SocialProfile = CuratorType['socialProfiles'];

  export let socialProfiles: SocialProfile = [];

  const socialTypes = ['instagram', 'x', 'facebook', 'linkedin'];

  const getSocials = (socials: NonNullable<SocialProfile>) =>
    socials.filter((social) => socialTypes.includes(social.type));

  $: preparedSocials = socialProfiles ? getSocials(socialProfiles) : [];
  $: site = socialProfiles?.find((social) => social.type === 'site');
</script>

{#if site}
  <div class="mb-5 flex flex-col gap-2 last:mb-0 md:flex-row md:items-center md:gap-0">
    <p class="flex-0.2 text-default-600 dark:text-dark-700 text-base font-normal">Site:</p>

    <div class="flex-0.7 flex items-center gap-3">
      <Icon name="website" classes="mt-0.5" />

      <a
        href="{site.value}"
        target="_blank"
        class="underline-hover underline-static text-base font-medium transition-colors"
        rel="nofollow"
      >
        {site.value}
      </a>
    </div>
  </div>
{/if}

{#if preparedSocials.length}
  <div class="flex flex-col gap-2 last:mb-0 md:flex-row md:items-center md:gap-0">
    <p class="flex-0.2 text-default-600 dark:text-dark-700 text-base font-normal">Socials:</p>

    <ul class="flex-0.7 flex flex-wrap items-center gap-8">
      {#each preparedSocials as social}
        <li>
          <a
            href="{social.value}"
            target="_blank"
            class="hover:text-default-500 font-medium transition-colors"
            rel="nofollow"
          >
            <Icon name="{social.type}" classes="w-5 h-5" />
          </a>
        </li>
      {/each}
    </ul>
  </div>
{/if}
